import React from 'react';
import styles from './index.module.scss';

const Index = () => (
  <div className={styles.wrapper}>
    <div className={styles.img}/>
    <p className={styles.title}>Сервис временно недоступен</p>
    <p className={styles.desc}>Пожалуйста, обратитесь к администратору</p>
  </div>
);

export default Index;
